<div class="cfs">
  <div class="cfs__section-label">{{ searchOnLabel() }}</div>

  <!-- Select All -->
  <div class="cfs__item">
    <mat-checkbox [checked]="isAllSelected()" (change)="toggleAll($event.checked)">
      {{ selectAllLabel() }}
    </mat-checkbox>
  </div>
  <hr class="cfs__inner-divider" />

  <!-- Groups -->
  @for (group of viewGroups(); track group.def) {
    <!-- Multi-item group: parent + children -->
    @if (group.items.length > 1) {
      <div class="cfs__item">
        <mat-checkbox [checked]="group.allSelected" (change)="toggleGroup($event.checked, group.def)">
          {{ group.label }}
        </mat-checkbox>
      </div>
      @for (item of group.items; track item.key) {
        <div class="cfs__item cfs__item--nested">
          <mat-checkbox
            [checked]="item.checked"
            [disabled]="item.disabled"
            [matTooltip]="item.disabled ? disabledTooltip() : ''"
            (change)="toggleItem($event.checked, item.key)"
            >{{ item.label }}</mat-checkbox
          >
        </div>
      }
    } @else {
      <!-- Single-item group: standalone checkbox -->
      <div class="cfs__item">
        <mat-checkbox
          [checked]="group.items[0].checked"
          [disabled]="group.items[0].disabled"
          [matTooltip]="group.items[0].disabled ? disabledTooltip() : ''"
          (change)="toggleItem($event.checked, group.items[0].key)"
          >{{ group.label }}</mat-checkbox
        >
      </div>
    }
  }
</div>
